import LocationMerchant from '../../components/locations/locationmerchant'
/**
 * LocationMerchantPage
 *
 * صفحه مربوط به نمایش مکان‌های فروشندگان. این صفحه صرفاً کامپوننت LocationMerchant را رندر می‌کند.
 *
 * @returns JSX.Element
 */

// Task Response:

// کد درست و بهینه است. نکته‌ای برای بهبود:
// 1. اگر نیاز به افزودن ویژگی‌های Layout یا متادیتای صفحه دارید، می‌توان Layout یا Head اضافه کرد.
//    مثلاً:
//    return <Layout><LocationMerchant /></Layout>

const LocationMerchantPage = () => {
  return (
    <LocationMerchant/>
  )
}

export default LocationMerchantPage
